<div class="account-font-edit-dialog-component">
  <div class="title-row dialog-row">
    <h2>
      @if (!fontType) {
        <span>
          @if (!editingFont) {
            {{ "settings.customization.fonts.add-your-own-font" | translate }}
          }
          @if (editingFont) {
            {{ "settings.customization.fonts.edit-your-own-font" | translate }}
          }
        </span>
      }
      @if (fontType === AccountCustomFontTypes.Default) {
        <span>{{ "settings.customization.fonts.custom-font-default" | translate }}</span>
      }
      @if (fontType === AccountCustomFontTypes.CssLink) {
        <span>{{ "settings.customization.fonts.custom-font-cssLink" | translate }}</span>
      }
      @if (fontType === AccountCustomFontTypes.UploadedFont) {
        <span>{{ "settings.customization.fonts.custom-font-uploaded" | translate }}</span>
      }
    </h2>
  </div>

  <div class="dialog-row dialog-content">
    <!-- CUSTOM FONTS  -->
    <!-- font-family -->
    @if (fontType !== AccountCustomFontTypes.Default) {
      <div class="font-section">
        <div class="label-input">{{ "settings.customization.fonts.family-name" | translate }}:</div>
        <mat-form-field class="font-name-field" appearance="outline">
          <input
            matInput
            type="text"
            [(ngModel)]="customFontFamilyName"
            (ngModelChange)="validateFamilyName()"
            placeholder="{{ 'settings.customization.fonts.family-name' | translate }}" />
          @if (familyNameError) {
            <mat-hint class="error">* {{ familyNameError }}</mat-hint>
          }
        </mat-form-field>
      </div>
    }

    <!-- css font -->
    @if (fontType === AccountCustomFontTypes.CssLink || !fontType) {
      <div class="font-section">
        <div class="description">Alt 1) {{ "settings.customization.fonts.1-step-css" | translate }}</div>
        <div class="label-input">{{ "settings.customization.fonts.css-link-input" | translate }}:</div>
        <mat-form-field class="css-link-field" appearance="outline">
          <input
            [matTooltip]="fontFiles?.length ? ('settings.customization.fonts.error-options' | translate) : customFontCssLink ? customFontCssLink : null"
            [disabled]="fontFiles?.length"
            matInput
            type="url"
            [(ngModel)]="customFontCssLink"
            (ngModelChange)="validateCssLink()"
            placeholder="{{ 'settings.customization.fonts.css-link-input' | translate }}" />
          @if (cssLinkError) {
            <mat-hint class="error">* {{ cssLinkError }}</mat-hint>
          }
        </mat-form-field>
      </div>
    }

    <!-- uploaded font -->
    @if (fontType === AccountCustomFontTypes.UploadedFont || !fontType) {
      <div class="font-section">
        <div class="description">
          Alt 2) {{ "settings.customization.fonts.2-step-uploaded-font" | translate }}
          @if (this.tierAccess?.isFontUploadAllowed === false) {
            <app-account-upgrade-tag></app-account-upgrade-tag>
          }
        </div>
        <div class="upload-font-files-label">
          <span>{{ "settings.customization.fonts.font-files" | translate }}:</span>
        </div>
        @if (uploadFontsError) {
          <div class="upload-font-files-error">{{ uploadFontsError }}</div>
        }
        @if (!!fontFiles && fontFiles.length > 0) {
          <div class="font-files-table">
            @for (fontFile of fontFiles; track fontFile; let index = $index) {
              <div class="font-file-row">
                <div class="font-file-name" [matTooltip]="fontFile.fileName">{{ fontFile.fileName }}</div>
                <mat-form-field class="font-file-weight" appearance="outline">
                  <mat-label>{{ "settings.customization.fonts.weight" | translate }}</mat-label>
                  <mat-select [(ngModel)]="fontFile.weight">
                    @for (weightOption of FONT_FILE_WEIGHTS; track weightOption) {
                      <mat-option [value]="weightOption">
                        <span [innerHTML]="weightOption"></span>
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <mat-form-field class="font-file-style" appearance="outline">
                  <mat-label>{{ "settings.customization.fonts.style" | translate }}</mat-label>
                  <mat-select [(ngModel)]="fontFile.style">
                    @for (styleOption of FONT_FILE_STYLES; track styleOption) {
                      <mat-option [value]="styleOption.key">
                        <span [innerHTML]="styleOption.value"></span>
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <mat-icon fontSet="material-symbols-outlined" class="font-file-delete" (click)="removeFontFile(index)">delete</mat-icon>
              </div>
            }
          </div>
        }
        <div
          class="upload-font-drop-area"
          [matTooltip]="customFontCssLink?.length ? ('settings.customization.fonts.error-options' | translate) : null"
          (click)="checkIfUploadFontDisabled($event)"
          (dragover)="handleDragEnter()"
          (dragleave)="handleDragLeave()"
          [style.borderColor]="uploadFontDragging ? 'var(--accentColor)' : ''"
          (drop)="handleDrop($event)">
          <input type="file" name="file" id="fontFile" (change)="handleInputChange($event)" />
          <div class="upload-font-text-row">
            <mat-icon class="material-icons" [style.color]="uploadFontDragging ? 'var(--accentColor)' : ''">cloud_upload</mat-icon>
            <div class="upload-font-text">
              @if (fontFileIsLoading) {
                <span>{{ "campaign.widget.component.image.status-uploading" | translate }}</span>
              }
              @if (!fontFileIsLoading) {
                <span>{{ "campaign.widget.component.image.status-waiting" | translate }}</span>
              }
            </div>
          </div>
        </div>
      </div>
    }

    <!-- check-box -->
    @if (fontType !== AccountCustomFontTypes.Default) {
      <div class="inject-font-checkbox-area">
        <div class="font-section">
          <mat-checkbox class="inject-font-checkbox" [(ngModel)]="fontExistsOnWebsiteSelected">
            <span>{{ "settings.customization.fonts.installed-on-website" | translate }}</span>
          </mat-checkbox>
          <div class="upload-font-hint">{{ "settings.customization.fonts.installed-on-website-descr" | translate }}</div>
        </div>
      </div>
    }
  </div>

  <div class="actions-row dialog-row">
    @if (savingInProgress && !familyNameError && !cssLinkError && !uploadFontsError) {
      <div class="saving-text">
        {{ "campaign.widget.sidebar.form-settings.saving" | translate }}
      </div>
    }
    <button mat-stroked-button class="secondary-button cancel" (click)="closeDialog()">{{ "generic.close" | translate | uppercase }}</button>
    <div
      [matTooltip]="
        !customFontCssLink?.length && !fontFiles?.length
          ? ('generic.validation.nothing-to-save' | translate)
          : familyNameError || cssLinkError || uploadFontsError
      ">
      <button
        mat-stroked-button
        [disabled]="
          (customFontCssLink?.length && fontFiles?.length !== 0) ||
          (!customFontCssLink?.length && !fontFiles?.length) ||
          familyNameError ||
          cssLinkError ||
          uploadFontsError
        "
        class="primary-button"
        (click)="createNewCustomFont()">
        <span>{{ (!editingFont ? "generic.create" : "generic.save") | translate | uppercase }}</span>
      </button>
    </div>
  </div>
</div>
